import AbstractElement from '../abstractElement';

export default class LinkedTextNode extends AbstractElement {
  constructor (textarea) {
    super();

    this.textarea = textarea;
    this.next = null;
  }
}
